import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Truck, MessageCircle } from "lucide-react";
import PageHero from "../components/PageHero";
import Seo from "../components/Seo";
import { pickupLocations, contact } from "../mock";

export default function LocationsPage() {
  return (
    <>
      <Seo
        title="Medicine Courier Pickup Locations in India | ShipMeds"
        description="Free doorstep medicine pickup across Delhi, Mumbai, Bangalore, Hyderabad, Chennai, Pune and all major Indian cities — then shipped worldwide by ShipMeds."
        path="/locations"
      />
      <PageHero title="Popular Pickup Locations" subtitle="We offer FREE doorstep medicine pickup across major Indian cities — then ship worldwide." crumb="Popular Locations" />
      <section className="py-16 lg:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {pickupLocations.map((l) => (
              <div key={l.city} className="group bg-slate-50 rounded-2xl p-6 border border-slate-100 hover:border-teal-200 hover:bg-teal-50/40 transition-colors">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-teal-500 to-blue-600 text-white flex items-center justify-center"><MapPin className="w-5 h-5" /></div>
                  <h3 className="font-bold text-slate-900 text-lg">{l.city}</h3>
                </div>
                <p className="text-sm text-slate-500 flex items-center gap-1.5"><Truck className="w-4 h-4 text-teal-500" />{l.note}</p>
              </div>
            ))}
          </div>
          <div className="mt-12 bg-gradient-to-r from-teal-700 to-teal-600 rounded-2xl p-8 text-center text-white">
            <h3 className="text-2xl font-bold mb-2">Not in the list? We still pick up!</h3>
            <p className="text-teal-100 mb-5">We provide free pickup across all of India. Just reach out and we'll arrange collection.</p>
            <div className="flex flex-wrap items-center justify-center gap-3">
              <a href={contact.whatsapp} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-bold px-6 py-3 rounded-lg transition-colors"><MessageCircle className="w-5 h-5" /> WhatsApp Us</a>
              <Link to="/contact" className="bg-white text-teal-700 font-bold px-6 py-3 rounded-lg hover:bg-teal-50 transition-colors">Contact Form</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
